// 记录切换语言
import { recordUserBehavior } from '@/api/common';
import {
  BehaviorEnum,
  LanguageEnum,
  ModuleEnum,
} from '@/definition/common/data.d';
type recordUserLangStatusType = 'empty' | 'loading' | 'success' | 'fail';
class ReportLangMonitor {
  // 初始化上报
  initRecordUserLang: boolean = false;
  // 状态
  recordUserLangStatus: recordUserLangStatusType = 'empty';
  // last set lang
  lastRecordUserLang: string = '';
  constructor() {
    this.initRecordUserLang = false;
    this.recordUserLangStatus = 'empty';
    this.lastRecordUserLang = '';
  }
  // 初始化只执行一次
  initRecordUserLangBehavior(lang: string) {
    // 没有初始化记录
    const isNotInitRecord = !this.initRecordUserLang;
    // 切换语言
    const isChangeRecordLang = this.lastRecordUserLang !== lang;
    if (isNotInitRecord || isChangeRecordLang) {
      this.lastRecordUserLang = lang;
      this.RecordUserLangBehavior(lang);
      this.initRecordUserLang = true;
    }
  }
  // 切换语言上报
  async RecordUserLangBehavior(lang: string) {
    // 不是loading
    const isNotLoading = this.recordUserLangStatus !== 'loading';
    if (isNotLoading) {
      try {
        this.recordUserLangStatus = 'loading';
        await recordUserBehavior({
          moduleId: ModuleEnum.PROJECT_SETTINGS,
          behaviourId:
            lang === LanguageEnum.ZH
              ? BehaviorEnum.SET_CH_LANG
              : BehaviorEnum.SET_EN_LANG,
        });
        this.recordUserLangStatus = 'success';
      } catch (e) {
        this.recordUserLangStatus = 'fail';
        console.error('记录用户语言失败\t', e);
      }
    }
  }
}

const reportLangMonitor = new ReportLangMonitor();

export { reportLangMonitor };
